import { render, staticRenderFns } from "./tigerResponsible.vue?vue&type=template&id=b3e4ee8a"
import script from "./tigerResponsible.vue?vue&type=script&lang=js"
export * from "./tigerResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports